export default class Vector2d {
    #x;
    #y;

    get x() {
        return this.#x;
    }

    set x(x) {
        this.#x = x;
    }

    get y() {
        return this.#y;
    }

    set y(y) {
        this.#y = y;
    }

    get length() {
        return Math.sqrt(this.#x ** 2 + this.#y ** 2);
    }

    get unitVector() {
        return new Vector2d(this.#x / this.length, this.#y / this.length);
    }

    constructor(x, y) {
        this.#x = x;
        this.#y = y;
    }

    multiplyingByNumber(number) {
        return new Vector2d(number * this.x, number * this.y);
    }

    incrementByNumber(x, y) {
        this.#x += x;
        this.#y += y;
    }
}
